var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTranslateGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.5H7.5M4.5 1.5V2.5M5.024 7.25C4.25405 6.45293 3.63774 5.52066 3.206 4.5M6.25 9H9.75M5.5 10.5L8 5.5L10.5 10.5M6.3755 2.5C5.8915 5.385 4.035 7.805 1.5 9.0645",
    stroke: "#78909C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTranslateGray);
export default __webpack_public_path__ + "static/media/ic_translate_gray.4ea4cd909a4692dec05b86e95fbe010a.svg";
export { ForwardRef as ReactComponent };